import { forwardRef, useRef } from "react";
import type React from "react";
import SignatureComponent, { SignatureComponentRef } from "@CubeComponents/Mui_Form/SignatureComponent";

interface SignDrawProps {
  setCreatedSignature: (data: string) => void;
  initialImageUrl?: string;
}

const SignDraw = forwardRef<SignatureComponentRef, SignDrawProps>(({ setCreatedSignature, initialImageUrl }, ref) => {
  const localRef = useRef<SignatureComponentRef>(null);
  const signDrawRef = (ref as React.RefObject<SignatureComponentRef>) || localRef;

  const saveBtnClick = () => {
    setCreatedSignature(signDrawRef.current.getSignature());
  };
  return (
    <SignatureComponent
      ref={signDrawRef}
      id="signature"
      className="h-[12.5rem] w-full rounded-sm border border-[var(--primary-blue)]"
      change={saveBtnClick}
      saveWithBackground={false}
      initialImageUrl={initialImageUrl}
    />
  );
});
SignDraw.displayName = "SignDraw";
export default SignDraw;
